export const useInstallationName = (str, installationName) => {
  if (str && installationName) {
    return "Unichat";
  }
  return str;
};

export default {
  methods: {
    useInstallationName,
  },
};
